import React from "react";

export default function CasosResueltos() {
  return (
    <div className="relative bg-gray-900 text-white py-16 px-6">
      {/* Fondo gris oscuro */}
      <div className="absolute inset-0 bg-gray-900 opacity-100"></div>

      {/* Contenido de la sección */}
      <div className="relative z-10 text-center">
        {/* Título de la sección */}
        <h2 className="text-4xl font-semibold mb-8">Casos Resueltos</h2>

        {/* Contenedor de los casos */}
        <div className="flex flex-wrap justify-center gap-12">
          {/* Caso 1: Incendio en Restaurante */}
          <div className="w-full sm:w-80 bg-white rounded-lg shadow-lg overflow-hidden transform transition duration-500 hover:scale-105">
            <img
              src="/images/a.jpeg"
              alt="Incendio en Restaurante"
              className="w-full h-48 object-cover"
            />
            <div className="p-6">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Incendio en Restaurante</h3>
              <p className="text-gray-700 mb-4">
                Se investiga el incendio ocurrido en la cocina de un restaurante en febrero de 2020. La causa probable fue un cortocircuito eléctrico en un horno.
              </p>
              <p className="text-gray-600 font-medium">Recomendaciones:</p>
              <p className="text-gray-600">Instalaciones sectorizadas y mantenimiento periódico de los equipos.</p>
            </div>
          </div>

          {/* Caso 2: Incendio en Almacén de Productos Químicos */}
          <div className="w-full sm:w-80 bg-white rounded-lg shadow-lg overflow-hidden transform transition duration-500 hover:scale-105">
            <img
              src="/images/b.jpeg"
              alt="Incendio en Almacén de Productos Químicos"
              className="w-full h-48 object-cover"
            />
            <div className="p-6">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Incendio en Almacén de Productos Químicos</h3>
              <p className="text-gray-700 mb-4">
                Un incendio ocurrido en abril de 2022 en un almacén industrial. La causa fue la combustión de productos químicos.
              </p>
              <p className="text-gray-600 font-medium">Recomendaciones:</p>
              <p className="text-gray-600">Sectorización y clasificación de productos, y medidas de seguridad mejoradas.</p>
            </div>
          </div>

          {/* Caso 3: Explosión de Garrafa de GLP */}
          <div className="w-full sm:w-80 bg-white rounded-lg shadow-lg overflow-hidden transform transition duration-500 hover:scale-105">
            <img
              src="/images/a.jpeg"
              alt="Explosión de Garrafa de GLP"
              className="w-full h-48 object-cover"
            />
            <div className="p-6">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Explosión de Garrafa de GLP</h3>
              <p className="text-gray-700 mb-4">
                Un caso de explosión en abril de 2023 en una cocina de rotisería. La causa fue una fuga de gas debido a una conexión defectuosa.
              </p>
              <p className="text-gray-600 font-medium">Conclusión:</p>
              <p className="text-gray-600">Incendio accidental debido a la fuga de gas.</p>
            </div>
          </div>

          {/* Caso 4: Incendio en Edificio de Oficinas */}
          <div className="w-full sm:w-80 bg-white rounded-lg shadow-lg overflow-hidden transform transition duration-500 hover:scale-105">
            <img
              src="/images/d.jpeg"
              alt="Incendio en Edificio de Oficinas"
              className="w-full h-48 object-cover"
            />
            <div className="p-6">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Incendio en Edificio de Oficinas</h3>
              <p className="text-gray-700 mb-4">
                En septiembre de 2023, un incendio en una oficina debido a trabajo en caliente con una soldadora eléctrica.
              </p>
              <p className="text-gray-600 font-medium">Recomendaciones:</p>
              <p className="text-gray-600">Implementar un plan de prevención, capacitación al personal y cultura de trabajo seguro.</p>
            </div>
          </div>

          {/* Caso 5: Incendio Vehicular */}
          <div className="w-full sm:w-80 bg-white rounded-lg shadow-lg overflow-hidden transform transition duration-500 hover:scale-105">
            <img
              src="/images/e.jpeg"
              alt="Incendio Vehicular"
              className="w-full h-48 object-cover"
            />
            <div className="p-6">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Incendio Vehicular</h3>
              <p className="text-gray-700 mb-4">
                En mayo de 2024, un incendio en la ruta 7 debido a un cortocircuito en el sistema de arranque de un vehículo.
              </p>
              <p className="text-gray-600 font-medium">Conclusión:</p>
              <p className="text-gray-600">Incendio accidental por cortocircuito eléctrico.</p>
            </div>
          </div>

          <div className="w-full sm:w-80 bg-white rounded-lg shadow-lg overflow-hidden transform transition duration-500 hover:scale-105">
  <h3 className="text-2xl font-semibold text-gray-800 mb-4">Evaluación de Riesgos de Incendio</h3>
  <p className="text-gray-700 text-base mb-4">
    Compartimos un caso práctico donde aplicamos un análisis integral del riesgo de incendio en una planta industrial, detallando métodos, criterios técnicos y soluciones aplicadas para reducir la carga de fuego y mejorar la seguridad.
  </p>
  <a
    href="https://www.linkedin.com/posts/carlos-laspina-32a266362_el-arte-de-investigar-un-incendio-cuando-activity-7334726796858351617-y4I1?utm_source=social_share_send&utm_medium=member_desktop_web&rcm=ACoAAFoYSFIB8XrOF3kht9i4LqfzDKEAeEVdqrQ" // ← Cambiá esto por el link real
    target="_blank"
    rel="noopener noreferrer"
    className="inline-block bg-blue-600 text-white px-5 py-2 rounded-lg font-semibold hover:bg-blue-700 transition"
  >
    Ver en LinkedIn
  </a>
</div>
          

        </div>
      </div>
    </div>
  );
}
